import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {MetaService} from './shared/services/meta.service';
import {META_TAGS} from './shared/config/meta-tags.config';
import {filter} from 'rxjs/operators';
import localeEs from '@angular/common/locales/es';
import {registerLocaleData} from '@angular/common';

registerLocaleData(localeEs, 'es-ES');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [
    RouterOutlet
  ]
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private metaService: MetaService
  ) {
  }

  ngOnInit() {
    // Escuchar cambios de ruta
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // Obtener la ruta actual sin los parámetros
      const currentRoute = event.urlAfterRedirects.split('/')[1] || 'home';

      // Actualizar meta tags según la ruta
      const metaTags = META_TAGS[currentRoute] || META_TAGS['home'];
      this.metaService.updateMetaTags(metaTags);
    });
  }
}
